import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { toastr } from 'react-redux-toastr'
import Select from 'react-select';
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ReactComponent as SearchIcon } from '../../../../../assets/search-icon.svg';
import CustomOverlayTrigger from "../../CustomOverlayTrigger"
import { tooltipIcon } from '../../helpers/iconHelpers'
import CustomButton from '../../CustomButton'
import { associateDriverCardTrip } from "../../../../../shared/api/action/DriverActions";

const ModalSelectDriver = (props) => {
	const dispatch = useDispatch();
	const { t, i18n } = useTranslation('translation', { keyPrefix: 'driversPage.modalSelectNewDriver' });
	const { onHide, drivers, selectedRow, isUsingDriverFaceID, getDeviceTrips } = props;

	const [selectedDriver, setSelectedDriver] = useState({});
	const [term, setTerm] = useState('');
	const [selectedDriverImgIds, setSelectedDriverImgIds] =  useState([]); // useState(selectedRow?.photos?.map(e => e = e.id) || []);
	const driversList = (drivers.map(({ id, name }) => ({ value: name, label: name, id })));

	const onSelect = (e) => {
		const obj = drivers.find(({ id }) => id === e.id);
		setSelectedDriver(obj);
	}

	const toggleLoader = useCallback((show) => {
		dispatch({ type: 'TOGGLE_LOADER', payload: show });
	}, [dispatch]);

	const Apply = () => {
		if (!selectedDriver.id
			|| !selectedRow.id
		) {
			toastr.error(t('selectDriver'));
			return
		}

		toggleLoader(true);
		const params = {
			driverId: selectedDriver.id,
			trip_id: selectedRow.id,
		}
		if (isUsingDriverFaceID) {
			params.trip_avatars_ids = selectedDriverImgIds
		}
		associateDriverCardTrip(params)
			.then((res) => {
				toggleLoader(false);
				getDeviceTrips && getDeviceTrips();
				toastr.success('Success', res.data.response);
				onHide();
			})
			.catch((error) => {
				toggleLoader(false);

				let errDescription = i18n.t('errorMessage.errDescription');
				if (error.response.data.response.error) {
					errDescription = error.response.data.response.error
				}
				toastr.error(errDescription);
			})
	}

	const onSearch = (e) => {
		setTerm(e.value);
	}

	const handleimgDriver = (id) => {
		setSelectedDriverImgIds(selectedDriverImgIds.includes(id) ? selectedDriverImgIds.filter(e => e !== id) : [...selectedDriverImgIds, id]);
	};

	const customStyles = {
		control: (base, state) => ({
			...base,
			height: '24px',
			minHeight: '24px',
		}),
		menu: (provided) => ({
			...provided,
			marginTop: '0px',
			marginBottom: '0px',
		}),
		input: (provided) => ({
			...provided,
			margin: '0px',
			padding: '0px',
		}),
	};

	return (
		<Modal
			show
			className="assign-driver-modal"
			onHide={onHide}
		>
			<Modal.Header closeButton>
				<Modal.Title>{t('titleAssignDriver')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="form-group">
					{t('titleVehicle')}
					<span>{selectedRow.vehicle_name}</span>
				</div>
				<div className="form-group">
					{t('titleFrom')}
					<span>{selectedRow.timestamp}</span>
				</div>
				{isUsingDriverFaceID && <p className="description">{t('textAssignImages')}</p>}
				<div className="drivers-search">
					{isUsingDriverFaceID && <CustomOverlayTrigger
						title={t('titleNote')}
						body={t('note')}
						placement="top"
						prefix="info"
						closeBtn={true}
					>
						{tooltipIcon}
					</CustomOverlayTrigger>}
					<div className="drivers-select">
						<span className="label-driver-select">{t('Driver')}</span>
						<Select
							value={term}
							onChange={onSelect}
							onInputChange={onSearch}
							placeholder={t('placeholderSearch')}
							options={driversList}
							components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
							styles={customStyles}
						/>
						<SearchIcon style={{ width: '16px', height: '16px' }} />
					</div>
					<CustomButton variant="primary" disabled={!selectedDriver?.id} onClick={Apply}>{t('btnAssignToDriver')}</CustomButton>
				</div>
				{isUsingDriverFaceID && selectedRow?.photos ?
					<div className="photos-list">
						{selectedRow.photos.map(({ url, id }) => {
							return (
								<img
									key={id} src={url} alt={`driver-img-${id}`}
									className={`${selectedDriverImgIds.includes(id) ? 'active' : ''}`}
									onClick={() => handleimgDriver(id)}  />)
						})}
					</div>
					: null
				}
			</Modal.Body>
		</Modal >
	)
}

ModalSelectDriver.propTypes = {
	drivers: PropTypes.arrayOf(PropTypes.any).isRequired,
	selectedRow: PropTypes.object.isRequired,
	onHide: PropTypes.func.isRequired
};

export default ModalSelectDriver;
